import { gql } from '@apollo/client';

export const AUTHENTICATE = gql`
  query token($code: String!, $state: String!) {
    getToken(code: $code, state: $state) {
      user {
        id
        firstName
        lastName
        email
        tenantId
        cognitoUsername
        isActive
        userGroups {
          id
          name
          cognitoGroupName
          displayColour
        }
      }
      tokens {
        access_token
        id_token
        refresh_token
      }
      caslAbilities
    }
  }
`;
